<template>
  <Modal ref="modalRef" ok-style="danger" @ok="onConfirm">
    <template #title>Remove parent</template>
    <div>
      Remove the relationship to this parent?
    </div>
    <PersonCard :person-id="personIdRef" layout="small" show-profile-type show-profile-count="multiple" static/>
    <template #okText>Remove</template>
  </Modal>
</template>

<style lang="scss" scoped>
:deep(.modal-body) {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.person-card {
  margin-left: 1rem;
}
</style>

<script setup lang="ts">
import { ref } from 'vue'
import { FamilyRelationshipRole } from '@/rd/ResearchDataModel'
import Modal from '@/util/Modal.vue'
import PersonCard from '../PersonCard.vue'

const emit = defineEmits<{
  (e: 'remove', role: FamilyRelationshipRole): void
}>()

defineExpose({
  open,
})

const personIdRef = ref<string>()
const roleRef = ref(FamilyRelationshipRole.Father)
const modalRef = ref<InstanceType<typeof Modal>>()

function open(role: FamilyRelationshipRole, personId: string) {
  personIdRef.value = personId
  roleRef.value = role
  modalRef.value?.open()
}

function onConfirm() {
  modalRef.value?.close()
  emit('remove', roleRef.value)
}
</script>
